import React, { useMemo } from 'react';
import ModalContainer from 'design-v2/common/ModalContainer';
import Blockout from 'app/common/BlockoutsByService/Blockout';
import BlockoutTimePicker from 'external-components/blockout-by-service-editor/BlockoutTimePicker';
import { rootDisplayActions } from 'app/reducers/display/slice';
import BlockoutsByService from 'app/common/BlockoutsByService';
import { blockoutTypeEnums } from 'app/common/BlockoutsByService/types';
import { floorplanBlockoutsActions } from 'floorplan-v2/app/reducers/blockouts/slice';
import ViewActionsService from 'app/actions/view.actions';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import { useAppDispatch } from 'appRoot/Store';
import NewBlockoutBySection from 'external-components/blockout-by-service-editor/NewBlockoutBySection';
import store from 'floorplan-v2/app/appRoot/Store';
import { tableInteractionsActions } from 'floorplan-v2/app/reducers/tableInteractions/slice';
import { floorplanSettingsActions } from 'floorplan-v2/app/reducers/settings/slice';
import { ToastActionClean } from 'app/actions/toast.actions';
import { ToastType } from 'shared-types/SharedTypes';

const BlockoutModal = () => {
  const dispatch = useAppDispatch();

  const showBlockoutByService = useSelector((state: DiaryRootState) => state.rootDisplayReducer.showBlockoutByService);
  const showBlockout = useSelector((state: DiaryRootState) => state.rootDisplayReducer.showBlockout);
  const showBlockoutOnFp = useSelector((state: DiaryRootState) => state.rootDisplayReducer.showBlockoutOnFp);
  const showBlockoutTimePicker = useSelector((state: DiaryRootState) => state.rootDisplayReducer.showBlockoutTimePicker);
  const showBlockoutBySectionOnFp = useSelector((state: DiaryRootState) => state.rootDisplayReducer.showBlockoutBySectionOnFp);
  const floorplanBlockoutsForSave = useSelector((state: DiaryRootState) => state.floorplanBlockoutsReducer.floorplanBlockoutsForSave);


  const closeBlockoutToast = () => {
    dispatch(rootDisplayActions.setShowBlockout(false));
    dispatch(rootDisplayActions.setShowBlockoutOnFp(false));
  }
  const closeBlockoutBySectionToast = () => {
    dispatch(rootDisplayActions.setShowBlockoutBySectionOnFp(false));
  }
  const handleSaveForBlockout = (value: blockoutTypeEnums) => {
    closeBlockoutToast();
    switch (value) {
      case blockoutTypeEnums.bySection:
        dispatch(rootDisplayActions.setShowBlockoutBySectionOnFp(true));
        break;
      case blockoutTypeEnums.byTable:
        dispatch(floorplanBlockoutsActions.setActiveAddBlockoutsByTable(true));
        dispatch(floorplanSettingsActions.setFloorplanPattern('status'));
        ViewActionsService.onBlockoutByTable(blockoutTypeEnums.byTable);
        break;
      case blockoutTypeEnums.byTableAndSection:
        ViewActionsService.onBlockoutByTable(blockoutTypeEnums.byTableAndSection);
        break;
      case blockoutTypeEnums.byService:
        dispatch(rootDisplayActions.setShowBlockoutByService(true));
        break;
      default:
        break;
    }
  }
  const handleBlockoutTimePickerClose = () => {
    dispatch(rootDisplayActions.setShowBlockoutTimePicker(false));
  }
  const handleBlockoutTimePickerSave = () => {
    ViewActionsService.onBlockoutFinished(blockoutTypeEnums.byTable);

    dispatch(floorplanBlockoutsActions.resetFloorPlanBlockOuts());
    // if triggered by addBlockoutsByTable
    dispatch(floorplanBlockoutsActions.setActiveAddBlockoutsByTable(false));
    //quit section
    dispatch(rootDisplayActions.setShowBlockoutBySectionOnFp(false));
    ToastActionClean.showToast('Blockout created', ToastType.success);
    setTimeout(() => {
      ToastActionClean.clearToast();
    }, 3000)
  }
  const handleBlockoutBySectionSave = (selectedSections: string[]) => {
    dispatch(floorplanBlockoutsActions.setFloorplanBlockoutsForSave({
      blockedSections: selectedSections,
    }))
    dispatch(rootDisplayActions.setShowBlockoutTimePicker(true));
  }
  return (
    <div>
      <ModalContainer
        isOpen={showBlockout}
        onRequestClose={closeBlockoutToast}
      >
        <Blockout handleModalClose={closeBlockoutToast}
                  showBlockoutOnFp={showBlockoutOnFp}
                  handleSaveClick={handleSaveForBlockout}
        />
      </ModalContainer>
      <ModalContainer
        isOpen={showBlockoutBySectionOnFp && !showBlockoutTimePicker}
        onRequestClose={closeBlockoutBySectionToast}
        isMaxWidth={true}
        contentStyle={{
          maxWidth: 800,
        }}
      >
        <NewBlockoutBySection exit={closeBlockoutBySectionToast}
                              handleSaveClick={handleBlockoutBySectionSave}
        />
      </ModalContainer>
      <ModalContainer
        isOpen={showBlockoutTimePicker}
        onRequestClose={handleBlockoutTimePickerClose}
        isMaxWidth={true}
        contentStyle={{
          maxWidth: 600,
        }}
      >
        <BlockoutTimePicker exit={handleBlockoutTimePickerClose}
                            handleBlockoutTimePickerSave={handleBlockoutTimePickerSave}
                            floorplanBlockoutsForSave={floorplanBlockoutsForSave}
        />
      </ModalContainer>
      <ModalContainer
        isOpen={showBlockoutByService}
        onRequestClose={() => {
          dispatch(rootDisplayActions.setShowBlockoutByService(false));
        }}
        isMaxWidth={true}
        contentStyle={{
          maxWidth: 800,
        }}
      >
        <BlockoutsByService handleModalClose={() => {
          dispatch(rootDisplayActions.setShowBlockoutByService(false));
        }} />
      </ModalContainer>
    </div>
  );
};

export default BlockoutModal;
